import { Router } from 'aurelia-router';

export class Register {

    configureRouter(config, router) {
        config.map([
            { route: '', redirect: 'begin' },
            { name: 'register-begin', title: 'Registration', route: 'begin', moduleId: './obsolete_begin', nav: true, settings:{step: 'Verify Company'} },
            { name: 'register-details', route: 'details', moduleId: './details', nav: true, settings:{step: 'Company Details'} },
            { name: 'register-carrier-info', route: 'carrier-info', moduleId: './carrier-info', nav: true, settings:{step: 'Carrier Information'} },
            { route: 'animation-demo', moduleId: './animation-demo', nav: false },
            { name: 'register-complete', route: 'complete', moduleId: './complete', nav: true, settings:{step: 'Complete'} }
        ]);

        this.router = router;
    }

    router: Router;
}